import { useGetServiceTypeDetailQuery } from "services";

export function useServiceTypeDetail(serviceTypeId: number) {
    const { data: serviceTypeRes, isLoading } = useGetServiceTypeDetailQuery(serviceTypeId!, {
        skip: !serviceTypeId,
        refetchOnMountOrArgChange: true
    });

    return {
        serviceType: serviceTypeRes?.data,
        isLoading
    };
}
